import FirstStep from './processSteps/FirstStep/FirstStep';

// Steps
export const viewSteps = [
    {
        id: '1',
        content: (manageSubStepChange: () => void) => <FirstStep />
    }
];
